export default "__VITE_ASSET__5b029898__"